import { selector, selectorFamily } from "recoil";
import { ResponseModel } from "../model/response";
import { APILIST, request } from "../repository/api";
import { ResponseList } from "../model/responseList";
import { Notice } from "../model/notice";
import { Stipulation } from "../model/stipulation";
import {
  accessTokenState,
  carCompanyState,
  carState,
  certifyPhoneState,
  chargingState,
  checkAuthState,
  companyUserRegistState,
  findIdState,
  findPwState,
  justMembershipGrade,
  noticeDetailState,
  noticeMainState,
  noticeState,
  platformState,
  refreshTokenState,
  showUserState,
  smartroRoamingState,
  smartroState,
  smatroReigistBillingState,
  userChargingState,
  userExpiresState,
  userMembershipGrade,
  userPointListState,
  userPointState,
  userRegistState,
  variableState,
  popUpState,
  userRepayState,
  userPaidFailState,
  userInfoState,
  resendUserCardNumberState,
  resendReasonState,
  resendReasonDetailState,
  userExistsState,
  evWhereMemberState,
  requiredDataState,
  isEvWhereMemberState,
  userIntegratedState,
  requestMemberCardState,
  qrTenantQueryState,
  smartroTenantState,
} from "./atoms";
import { A } from "../styles/commonStyle";
import { object } from "yup";
import { getUserCloudIdFromToken, getUserIdFromToken } from "../util";

export const emailSelector = selector({
  key: `emailState`,
  get: async ({ get }) => {
    let res: ResponseModel<any> = await request(APILIST.FINDID, "get", get(findIdState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(findIdState, object);
  },
});

// 게시물 조회
export const noticeSelector = selector({
  key: `noticeSelector`,
  get: async ({ get }) => {
    if (get(noticeState) === undefined) return;
    let res: ResponseModel<ResponseList<Notice>> = await request(APILIST.NOTICE, "get", get(noticeState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(noticeState, object);
  },
});

// 게시물 상세 조회
export const noticeDetailSelector = selector({
  key: `noticeDetailSelector`,
  get: async ({ get }) => {
    if (get(noticeDetailState) === undefined) return;
    let res: ResponseModel<Notice> = await request(APILIST.NOTICE + "/" + get(noticeDetailState), "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(noticeDetailState, object);
  },
  cachePolicy_UNSTABLE: {
    eviction: "most-recent",
  },
});

// 게시물 메인 조회
export const noticeMainSelector = selector({
  key: `noticeMainSelector`,
  get: async ({ get }) => {
    if (get(noticeMainState) === undefined) return;
    let res: ResponseModel<ResponseList<Notice>> = await request(APILIST.NOTICE, "get", get(noticeMainState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(noticeMainState, object);
  },
});

// 팝업 게시물 조회
export const popupSelector = selector({
  key: `popupSelector`,
  get: async ({ get }) => {
    let res: ResponseModel<Notice[]> = await request(`${APILIST.NOTICE}/popup`, "get", get(popUpState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(popUpState, object);
  },
});




export const stipulationNonMemberPolicySelector = selector({
  key: `stipulationNonMemberPolicyState`,
  get: async ({ get }) => {
    let res: ResponseModel<Stipulation> = await request(APILIST.STIPULATION + "/이용약관 (비회원)", "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});
export const stipulationPolicySelector = selector({
  key: `stipulationPolicyState`,
  get: async ({ get }) => {
    let res: ResponseModel<Stipulation> = await request(APILIST.STIPULATION + "/이용약관", "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});
export const stipulationPrivacySelector = selector({
  key: `stipulationPrivacyState`,
  get: async ({ get }) => {
    let res: ResponseModel<Stipulation> = await request(APILIST.STIPULATION + "/개인정보처리방침", "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});

export const stipulation1Selector = selector({
  key: `stipulationSelector1`,
  get: async ({ get }) => {
    let res: ResponseModel<Stipulation> = await request(APILIST.STIPULATION + "/이용약관", "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});
export const stipulation2Selector = selector({
  key: `stipulationSelector2`,
  get: async ({ get }) => {
    let res: ResponseModel<Stipulation> = await request(APILIST.STIPULATION + "/개인정보 수집 및 이용 동의 (회원가입)", "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});

export const stipulation3Selector = selector({
  key: `stipulationSelector3`,
  get: async ({ get }) => {
    let res: ResponseModel<Stipulation> = await request(APILIST.STIPULATION + "/위치기반 서비스 이용약관", "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});

export const stipulationSOCSelector = selector({
  key: `stipulationSOCSelector`,
  get: async ({ get }) => {
    let res: ResponseModel<Stipulation> = await request(APILIST.STIPULATION + "/스마트충전기 배터리 정보 제3자 제공", "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});

export const stipulationQR1Selector = selector({
  key: `stipulationQR1Selector`,
  get: async ({ get }) => {
    let res: ResponseModel<Stipulation> = await request(APILIST.STIPULATION + "/전자금융거래 이용약관", "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});
export const stipulationQR2Selector = selector({
  key: `stipulationQR2Selector`,
  get: async ({ get }) => {
    let res: ResponseModel<Stipulation> = await request(APILIST.STIPULATION + "/개인정보 수집 및 이용 동의 (비회원 결제)", "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});

export const carCompanySelector = selector({
  key: `carCompanySelector`,
  get: async ({ get }) => {
    let res: ResponseModel<any> = await request(APILIST.CARCOMPANY, "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(carCompanyState, object);
  },
  cachePolicy_UNSTABLE: {
    eviction: "most-recent",
  },
});

export const carSelector = selector({
  key: `carSelector`,
  get: async ({ get }) => {
    if (get(carState) === undefined) {
      return;
    }
    const carNm = { nm: get(carState) };
    let res: ResponseModel<any> = await request(APILIST.CAR, "get", carNm);
    return res;
  },
  set: ({ set }, object: any) => {
    set(carState, object);
  },
  cachePolicy_UNSTABLE: {
    eviction: "most-recent",
  },
});

export const showUserSelector = selectorFamily({
  key: `showUserSelector`,
  get:
    ({ token }: { token: string }) =>
      async ({ get }) => {
        var cloudId = await getUserCloudIdFromToken();
        if (cloudId == undefined || cloudId == null) {
          var userId = get(showUserState);
          if (userId == undefined || userId == null) return;
          let res: ResponseModel<any> = await request(APILIST.SHOWUSER + "/" + userId, "get");
          return res;
        } else {
          let res: ResponseModel<any> = await request(APILIST.INTEGRATED_USER + "/" + cloudId + '/show', "get");
          return res;
        }
      },
  set:
    () =>
      ({ set }, object: any) => {
        set(showUserState, object);
      },
  cachePolicy_UNSTABLE: {
    eviction: "most-recent",
  },
});

export const findChargerQrSelector = selector({
  key: `findChargerQrSelector`,
  get: async ({ get }) => {
    if (get(variableState) === undefined) return;
    let res: ResponseModel<ResponseList<any>> = await request(APILIST.FIND_CHARGER_QR, "get", get(variableState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});

export const findChargerQrTenantSelector = selector({
  key: `findChargerQrTenantSelector`,
  get: async ({ get }) => {
    const query = get(qrTenantQueryState) as { tenantCode: string; qrcode: string } | undefined;
    if (query === undefined) return;
    let res: ResponseModel<any> = await request(`${APILIST.FIND_CHARGER_QR_TENANT}/${query.tenantCode}/${query.qrcode}`, "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(qrTenantQueryState, object);
  },
});

export const showChargerRecordSelector = selector({
  key: `showChargerRecordSelector`,
  get: async ({ get }) => {
    if (get(variableState) === undefined) return;
    let res: ResponseModel<ResponseList<any>> = await request(APILIST.SHOW_CHARGING_RECORD + `/${get(variableState)}`, "get");
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});

export const platformSelector = selector({
  key: `platformSelector`,
  get: async ({ get }) => {
    if (get(platformState) === undefined) return;
    let res: ResponseModel<ResponseList<any>> = await request(APILIST.PLATFORM, "get", get(platformState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(platformState, object);
  },
});

export const loginPostSelector = selector({
  key: `loginSelector`,
  get: async ({ get }) => {
    if (get(variableState) === undefined) return;
    var data: any = get(variableState);
    let res: ResponseModel<any>;
    if (data.ssbyp) {
      res = await request(APILIST.SOCIAL_LOGIN, "post", undefined, get(variableState));
    } else {
      res = await request(APILIST.LOGIN, "post", undefined, get(variableState));
    }
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});

export const accessTokenSelector = selector({
  key: `accessTokenSelector`,
  get: async ({ get }) => {
    if (get(accessTokenState) === undefined) return;
    let res: ResponseModel<any> = await request(APILIST.USER + "/accessTokenCheck", "get", get(accessTokenState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(accessTokenState, object);
  },
});

export const refreshTokenSelector = selector({
  key: `refreshTokenSelector`,
  get: async ({ get }) => {
    if (get(refreshTokenState) === undefined) return;
    let res: ResponseModel<any> = await request(APILIST.USER + "/refreshTokenCheck", "get", get(refreshTokenState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(refreshTokenState, object);
  },
});

export const changePasswordPostSelector = selector({
  key: `changePasswordSelector`,
  get: async ({ get }) => {
    if (get(variableState) === undefined) return;
    var cloudId = await getUserCloudIdFromToken();
    var data: any = get(variableState);
    let res;
    if (cloudId) {
      res = await request(APILIST.INTEGRATED_USER_UPDATE_PASSWORD, "post", undefined, data);
    } else {
      res = await request(APILIST.UPDATE_PASSWORD, "post", undefined, data);
    }
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});

export const changePaycardSelector = selector({
  key: `changePaycardSelector`,
  get: async ({ get }) => {
    if (get(variableState) === undefined) return;
    let res: ResponseModel<ResponseList<any>> = await request(APILIST.UPDATE_PAYCARD, "post", undefined, get(variableState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});

export const installRequestSelector = selector({
  key: `installRequestSelector`,
  get: async ({ get }) => {
    if (get(variableState) === undefined) return;
    let res: ResponseModel<any> = await request(APILIST.CHARGERREQ, "post", undefined, get(variableState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(variableState, object);
  },
});

export const certifyPhoneSelector = selector({
  key: `certifyPhoneSelector`,
  get: async ({ get }) => {
    if (get(certifyPhoneState) === undefined) return;
    let res: ResponseModel<any> = await request(APILIST.CERTIFI_PHONE, "post", undefined, get(certifyPhoneState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(certifyPhoneState, object);
  },
});

export const checkAuthSelector = selector({
  key: `checkAuthSelector`,
  get: async ({ get }) => {
    if (get(checkAuthState) === undefined) return;
    let res: ResponseModel<any> = await request(APILIST.CERTIFI_AUTHCODE, "post", undefined, get(checkAuthState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(checkAuthState, object);
  },
});

// 멤버 회원가입 및 수정도 multipart/form-data 형식으로 변경
export const userRegistSelector = selector({
  key: `userRegistSelector`,
  get: async ({ get }) => {
    if (get(userRegistState) === undefined) return;
    var userInfo: any = get(userRegistState);
    const billingInfo: any = get(smatroReigistBillingState)

    // FormData 객체 생성
    const formData = new FormData();

    // userInfo의 값들을 formData에 추가
    for (const key in userInfo) {
      if (userInfo[key] !== undefined) {
        formData.append(key, userInfo[key]);
      }
    }

    // billingInfo의 값들을 formData에 추가
    for (const key in billingInfo) {
      if (billingInfo[key] !== undefined) {
        formData.append(key, billingInfo[key]);
      }
    }

    const res: ResponseModel<any> = await request(APILIST.INTEGRATED_USER, "filePost", undefined, undefined, formData);
    return res;
  },
  set: ({ set }, object: any) => {
    set(userRegistState, object);
  },
});

export const userIntegratedSelector = selector({
  key: `userIntegratedSelector`,
  get: async ({ get }) => {
    if (get(userIntegratedState) === undefined) return;
    if (get(showUserState) === undefined) return;
    var userId = get(showUserState);
    var data = get(userIntegratedState);

    const res: ResponseModel<any> = await request(APILIST.INTEGRATED_USER + `/${userId}/conversion`, "put", undefined, data);
    return res;
  },
  set: ({ set }, object: any) => {
    set(userIntegratedState, object);
  },
});

export const userExistsSelector = selector({
  key: `userExistsSelector`,
  get: async ({ get }) => {
    if (get(userExistsState) === undefined) return;
    var query: any = get(userExistsState);
    const res: ResponseModel<any> = await request(APILIST.EXISTS_USER, "get", query);
    return res;
  },
  set: ({ set }, object: any) => {
    set(userExistsState, object);
  },
});

export const companyUserRegistSelector = selector({
  key: `companyUserRegistSelector`,
  get: async ({ get }) => {
    if (get(companyUserRegistState) === undefined) return;

    let companyInfo: any = get(companyUserRegistState);
    const billingInfo: any = get(smatroReigistBillingState)
    for (const key in billingInfo) {
      if (Object.hasOwnProperty.call(billingInfo, key)) {
        const value = billingInfo[key];
        companyInfo.append(key, value)
      }
    }
    const res: ResponseModel<any> = await request(APILIST.REGISTER_USER, "filePost", undefined, undefined, companyInfo);
    return res;
  },
  set: ({ set }, object: any) => {
    set(companyUserRegistState, object);
  },
});

export const findPwSelector = selector({
  key: `findPwSelector`,
  get: async ({ get }) => {
    if (get(findPwState) === undefined) return;
    let res: ResponseModel<any> = await request(APILIST.FINDPW, "get", get(findPwState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(findPwState, object);
  },
});

export const smartroSelector = selector({
  key: `smartroSelector`,
  get: async ({ get }) => {
    if (get(smartroState) === undefined) return;
    let res: ResponseModel<any> = await request(APILIST.SMARTRO_TEST, "post", undefined, get(smartroState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(smartroState, object);
  },
});

export const smartroRoamingSelector = selector({
  key: `smartroRoamingSelector`,
  get: async ({ get }) => {
    if (get(smartroRoamingState) === undefined) return;
    let res: ResponseModel<any> = await request(APILIST.SMARTRO, "post", undefined, get(smartroRoamingState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(smartroRoamingState, object);
  },
});

export const smartroTenantSelector = selector({
  key: `smartroTenantSelector`,
  get: async ({ get }) => {
    if (get(smartroTenantState) === undefined) return;
    let res: ResponseModel<any> = await request(APILIST.SMARTRO_TENANT, "post", undefined, get(smartroTenantState));
    return res;
  },
  set: ({ set }, object: any) => {
    set(smartroTenantState, object);
  },
});

export const userChargingSelector = selector({
  key: `userChargingSelector`,
  get: async ({ get }) => {
    var userId = get(showUserState);
    if (userId == undefined || userId == null) return;
    let token: ResponseModel<any> = await request(APILIST.CSMS_KEY, 'post', undefined, { "apiKey": process.env.REACT_APP_CSMS_API_KEY as string }, undefined, undefined, "CSMS");
    let res: ResponseModel<any> = await request(APILIST.CSMS_CHARGING + `/${userId}/chrgr-elctc`, 'token', get(userChargingState), undefined, undefined, `Bearer ${token.data.accessToken}`, "CSMS");
    return res;

  },
  set: ({ set }, object: any) => {
    set(userChargingState, object);
  },
});

export const userPointSelector = selector({
  key: `userPointSelector`,
  get: async ({ get }) => {
    const userPoint = get(userPointState);
    if (userPoint?.membership_card_number === undefined) return;
    if (userPoint && userPoint.membership_card_number) {
      let token: ResponseModel<any> = await request(APILIST.POINT_TOKEN, 'post', undefined, { "api_key": process.env.REACT_APP_COUPON_POINT_API_KEY as string }, undefined, undefined, "POINT");
      let res: ResponseModel<any> = await request(APILIST.POINT, 'token', userPoint, undefined, undefined, `Bearer ${token.data.access_token}`, "POINT");
      return res;
    } else {
      // membership_card_number 값이 없거나 undefined인 경우에 대한 처리
      return null;
    }
  },
  set: ({ set }, object: any) => {
    set(userPointState, object);
  },
});

export const userPointListSelector = selector({
  key: `userPointListSelector`,
  get: async ({ get }) => {
    const userPoint = get(userPointListState);
    const userInfo = get(userInfoState);
    if (userInfo == undefined || userInfo == null) return;
    let token: ResponseModel<any> = await request(APILIST.POINT_TOKEN, 'post', undefined, { "api_key": process.env.REACT_APP_COUPON_POINT_API_KEY as string }, undefined, undefined, "POINT");
    var cloudId = await getUserCloudIdFromToken();
    let res: ResponseModel<any>
    if (cloudId) {
      res = await request(APILIST.POINT_LIST + `/${userInfo.cardData[0]?.cardNo}`, 'token', userPoint, undefined, undefined, `Bearer ${token.data.access_token}`, "POINT");
    } else {
      res = await request(APILIST.POINT_LIST + `/${userInfo.cardData?.cardNo}`, 'token', userPoint, undefined, undefined, `Bearer ${token.data.access_token}`, "POINT");
    }
    if (!res) return;
    return res;
  },
  set: ({ set }, object: any) => {
    set(userPointListState, object);
  },
});

export const userExpiresSelector = selector({
  key: `userExpiresSelector`,
  get: async ({ get }) => {
    const userInfo = get(userInfoState);
    if (userInfo == undefined || userInfo == null) return;
    var cloudId = await getUserCloudIdFromToken();
    let token: ResponseModel<any> = await request(APILIST.POINT_TOKEN, 'post', undefined, { "api_key": process.env.REACT_APP_COUPON_POINT_API_KEY as string }, undefined, undefined, "POINT");
    let res: ResponseModel<any>;
    if (cloudId) {
      res = await request(APILIST.POINT_EXPIRES + `/${userInfo.cardData[0]?.cardNo}`, 'token', undefined, undefined, undefined, `Bearer ${token.data.access_token}`, "POINT");
    } else {
      res = await request(APILIST.POINT_EXPIRES + `/${userInfo.cardData?.cardNo}`, 'token', undefined, undefined, undefined, `Bearer ${token.data.access_token}`, "POINT");
    }
    return res;
  },
  set: ({ set }, object: any) => {
    set(userExpiresState, object)
  }
})

export const getUserMembershipGradeSelector = selector({
  key: `getUserMembershipGradeSelector`,
  get: async ({ get }) => {
    var userId = get(showUserState);
    if (userId == undefined || userId == null) return;
    let res: ResponseModel<any> = await request(APILIST.MEMBERSHIP_USER_GRADE + `/${userId}`, 'get', { cloudCode: 'TD' }, undefined, undefined, undefined, "MEMBERSHIP");
    return res;
    return {};
  },
  set: ({ set }, object: any) => {
    set(userMembershipGrade, object)
  }
})

export const getJustMembershipGradeSelector = selector({
  key: `getJustMembershipGradeSelector`,
  get: async ({ get }) => {
    if (get(justMembershipGrade) !== undefined) return;
    let res: ResponseModel<any> = await request(APILIST.MEMBERSHIP_JUST_GRADE, 'get', { cloudCode: 'TD' }, undefined, undefined, undefined, "MEMBERSHIP");
    return res;
  },
  set: ({ set }, object: any) => {
    set(justMembershipGrade, object)
  }
})

export const requestMemberCardSelector = selector({
  key: 'requestMemberCardSelector',
  get: async ({ get }) => {
    if (!get(requestMemberCardState)) return;
    const cloudId = await getUserCloudIdFromToken();
    var data = get(requestMemberCardState);
    if (!cloudId) return;
    let res: ResponseModel<any> = await request(APILIST.USER + `/${cloudId}/membercard_request`, 'post', undefined, data);
    return res;
  },
  set: ({ set }, object: any) => {
    set(requestMemberCardState, object)
  }
});

export const userRepaySelector = selectorFamily({
  key: 'userRepaySelector',
  get: (param: any) => async ({ get }) => {
    var userId = get(showUserState);
    if (userId == undefined || userId == null) return;
    let token: ResponseModel<any> = await request(APILIST.CSMS_KEY, 'post', undefined, { "apiKey": process.env.REACT_APP_CSMS_API_KEY as string }, undefined, undefined, "CSMS");
    let res: ResponseModel<any> = await request(APILIST.CSMS_REPAY, 'tokenPost', undefined, { 'userId': userId }, undefined, `Bearer ${token.data.accessToken}`, "CSMS");
    return res;
  },
});

export const userPaidFailSelector = selector({
  key: `userPaidFailSelector`,
  get: async ({ get }) => {
    var userId = get(showUserState);
    if (userId === undefined || userId === null) return;
    let token: ResponseModel<any> = await request(APILIST.CSMS_KEY, 'post', undefined, { "apiKey": process.env.REACT_APP_CSMS_API_KEY as string }, undefined, undefined, "CSMS");
    let res: ResponseModel<any> = await request(APILIST.CSMS_PAID_FAIL + `/user/${userId}/paid-fail`, 'token', undefined, undefined, undefined, `Bearer ${token.data.accessToken}`, "CSMS");
    return res;
  },
  set: ({ set }, object: any) => {
    set(userPaidFailState, object);
  },
});

export const resendUserCardSelector = selector({
  key: `resendUserCardSelector`,
  get: async ({ get }) => {
    let res: ResponseModel<any> = await request(
      APILIST.USER_CARD + '/' + get(resendUserCardNumberState) + '/reissue',
      'post',
      undefined,
      {
        'reason': get(resendReasonState),
        'reasonDetail': get(resendReasonDetailState)
      },
    );
    return res;
  },
  set: ({ set }, object: any) => {
    set(resendUserCardNumberState, object);
  },
});

export const evWhereMemberSelector = selector({
  key: `evWhereMemberSelector`,
  get: async ({ get }) => {
    if (get(evWhereMemberState) === undefined) return;
    var recoilData = get(evWhereMemberState);

    const isRequesting = get(isEvWhereMemberState);
    if (isRequesting) return;

    var data = {
      lgnId: recoilData?.lgn_Id,
      ssbyp: recoilData?.ssbyp,
      lgnPassword: recoilData?.lgnPassword,
    };
    let res: ResponseModel<any> = await request(APILIST.EVWHERE_MEMBER, 'post', undefined, data);
    return res;
  },
  set: ({ set }, object: any) => {
    set(isEvWhereMemberState, object);
  },
});